import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { BlogType } from "../../types/types";
import { fetchBlogs } from "../../service/service";
import Blog from "../NewBlogPage/Blog";
import PrimaryButton from "../common/PrimaryButton";
import { useNavigate } from "react-router-dom";

const NewsInsight = () => {
  const [blogs, setBlogs] = useState<BlogType[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const blogsResponse = await fetchBlogs();
      if (blogsResponse.status === 200) {
        setBlogs(blogsResponse.blogs as BlogType[]);
      }
    })();
  }, []);
  const dataContext = useContext(AuthContext);
  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${
        theme === "dark" ? "bg-primary" : "bg-[#141414]"
      } transition-all duration-500`}
    >
      <div className="max-w-screen-2xl mx-auto px-5 sm:px-20 py-8 sm:py-28">
        <h2
          className={`${
            theme === "dark" ? "" : ""
          } text-white bricolage-grotesque-bold text-3xl sm:text-5xl text-center`}
        >
          Insights, Ideas and Everything in Between 
        </h2>
        <div
          className={`${
            theme === "dark" ? "text-white" : "text-white"
          } grid grid-col-1 lg:grid-cols-3 gap-10 py-10`}
        >
          {" "}
          {blogs.slice(0, 3).map((blog, index) => (
            <Blog key={index} blog={blog} />
          ))}
        </div>
        <div className="flex justify-center">
          <PrimaryButton
            onClick={() => navigate("/blog")}
            className={`${
              theme === "dark"
                ? "bg-white border !text-black hover:!text-white hover:bg-secondary border-secondary hover:shadow-[0_0_10px_2px] hover:shadow-secondary"
                : "border  border-secondary bg-white !text-black hover:shadow-[0_0_10px_2px] hover:shadow-secondary inset-0 hover:!text-white hover:bg-secondary"
            } relative mt-10 z-10 transition-all duration-500`}
          >
            Go to Blogs
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default NewsInsight;
